import React from 'react';
import { Box, Grid, Paper, Typography, Button, Radio, Stack, RadioGroup, FormControlLabel, Divider } from '@mui/material';
import { useThemeSettings } from '../../contexts/ThemeContext';

const ThemePreview = ({ preset, selected, onSelect }) => {
  return (
    <Paper
      variant={selected ? 'elevation' : 'outlined'}
      elevation={selected ? 6 : 0}
      sx={{ p: 2, borderRadius: 2, cursor: 'pointer', position: 'relative' }}
      onClick={() => onSelect(preset.id)}
    >
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
        <Radio checked={selected} onChange={() => onSelect(preset.id)} />
        <Typography variant="subtitle1" fontWeight={600}>{preset.name}</Typography>
      </Stack>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Box sx={{ flex: 1, height: 10, bgcolor: preset.primary.main, borderRadius: 1 }} />
        <Box sx={{ flex: 1, height: 10, bgcolor: preset.secondary.main, borderRadius: 1 }} />
        <Box sx={{ flex: 1, height: 10, bgcolor: preset.background.paper, borderRadius: 1, border: '1px solid', borderColor: 'divider' }} />
      </Box>
    </Paper>
  );
};

const ThemeSettings = () => {
  const { themeId, setThemeId, presets, fontId, setFontId, fonts } = useThemeSettings();

  const handleSelect = (id) => setThemeId(id);
  const handleFontChange = (e) => setFontId(e.target.value);

  return (
    <Box>
      <Typography variant="h6" gutterBottom>Appearance</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Choose a theme to personalize your dashboard. This applies instantly and is saved to this device.
      </Typography>
      <Grid container spacing={2}>
        {presets.map(preset => (
          <Grid item xs={12} sm={6} md={4} key={preset.id}>
            <ThemePreview preset={preset} selected={themeId === preset.id} onSelect={handleSelect} />
          </Grid>
        ))}
      </Grid>
      <Box sx={{ mt: 2 }}>
        <Button variant="outlined" onClick={() => setThemeId('default')}>Reset to Default</Button>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Typography variant="h6" gutterBottom>Font</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Select a font for the dashboard interface.
      </Typography>
      <RadioGroup value={fontId} onChange={handleFontChange}>
        <Grid container spacing={1}>
          {fonts.slice(0, 5).map(f => (
            <Grid item xs={12} sm={6} md={4} key={f.id}>
              <Paper variant={fontId === f.id ? 'elevation' : 'outlined'} elevation={fontId === f.id ? 4 : 0} sx={{ p: 2, borderRadius: 2 }}>
                <FormControlLabel
                  value={f.id}
                  control={<Radio />}
                  label={
                    <Box>
                      <Typography variant="subtitle1" sx={{ fontFamily: f.stack }}>{f.name}</Typography>
                      <Typography variant="caption" color="text.secondary" sx={{ fontFamily: f.stack }}>
                        The quick brown fox jumps over the lazy dog
                      </Typography>
                    </Box>
                  }
                />
              </Paper>
            </Grid>
          ))}
        </Grid>
      </RadioGroup>
    </Box>
  );
};

export default ThemeSettings;
